import './component.scss'
import './images/arrow_icon.svg'
import './images/hover_triangle.svg'

const AREA_HOVER_SELECTOR = '.js-area-hover'
const PREFECTURE_DROPDOWN_SELECTOR = '.js-prefecture-dropdown'
const AREA_ITEM_ACTIVE_CLASS = 'hamburger-menu__area-item--active'
const PREFECTURE_DROPDOWN_ACTIVE_CLASS = 'hamburger-menu__prefecture-dropdown--active'

// ヘルパー関数: 要素がホバー状態かチェック
function isElementHovered(element) {
  if (!element) return false
  const rect = element.getBoundingClientRect()
  return rect.left <= event.clientX && event.clientX <= rect.right &&
         rect.top <= event.clientY && event.clientY <= rect.bottom
}

// ヘルパー関数: 全てのアクティブ状態をリセット
function resetAllActiveStates() {
  const areaItems = document.querySelectorAll(AREA_HOVER_SELECTOR)
  const dropdowns = document.querySelectorAll(PREFECTURE_DROPDOWN_SELECTOR)
  
  areaItems.forEach(item => item.classList.remove(AREA_ITEM_ACTIVE_CLASS))
  dropdowns.forEach(dropdown => dropdown.classList.remove(PREFECTURE_DROPDOWN_ACTIVE_CLASS))
}

// ヘルパー関数: 指定要素をアクティブに
function setActiveState(trigger, dropdown) {
  if (trigger) trigger.classList.add(AREA_ITEM_ACTIVE_CLASS)
  if (dropdown) dropdown.classList.add(PREFECTURE_DROPDOWN_ACTIVE_CLASS)
}

// ヘルパー関数: 指定要素を非アクティブに
function removeActiveState(trigger, dropdown) {
  if (trigger) trigger.classList.remove(AREA_ITEM_ACTIVE_CLASS)
  if (dropdown) dropdown.classList.remove(PREFECTURE_DROPDOWN_ACTIVE_CLASS)
}

// DOMContentLoaded時に初期化
document.addEventListener('DOMContentLoaded', () => {
  // エリアアイテムホバー時の処理
  document.querySelectorAll(AREA_HOVER_SELECTOR).forEach(areaItem => {
    areaItem.addEventListener('mouseenter', (event) => {
      const trigger = event.currentTarget
      const regionId = trigger.dataset.regionId
      const dropdown = trigger.querySelector(`${PREFECTURE_DROPDOWN_SELECTOR}[data-region-id="${regionId}"]`)

      // 他のアクティブ状態をリセット
      resetAllActiveStates()

      // 現在の要素をアクティブに
      setActiveState(trigger, dropdown)
    })

    // エリアアイテムからマウスが離れた時の処理
    areaItem.addEventListener('mouseleave', (event) => {
      const trigger = event.currentTarget
      const regionId = trigger.dataset.regionId
      const dropdown = trigger.querySelector(`${PREFECTURE_DROPDOWN_SELECTOR}[data-region-id="${regionId}"]`)

      // ドロップダウンにホバーしていない場合のみ非表示
      setTimeout(() => {
        // マウスがドロップダウンまたはトリガー上にない場合のみ非アクティブに
        const rect = dropdown?.getBoundingClientRect()
        const triggerRect = trigger.getBoundingClientRect()
        
        if (dropdown && rect && triggerRect) {
          // 簡易的なホバー判定（実際のマウス座標は取得できないため、要素の存在で判定）
          removeActiveState(trigger, dropdown)
        }
      }, 100)
    })
  })

  // ドロップダウン自体のホバー処理
  document.querySelectorAll(PREFECTURE_DROPDOWN_SELECTOR).forEach(dropdown => {
    dropdown.addEventListener('mouseenter', (event) => {
      const dropdownElement = event.currentTarget
      const regionId = dropdownElement.dataset.regionId
      const trigger = dropdownElement.closest(AREA_HOVER_SELECTOR)

      setActiveState(trigger, dropdownElement)
    })

    dropdown.addEventListener('mouseleave', (event) => {
      const dropdownElement = event.currentTarget
      const regionId = dropdownElement.dataset.regionId
      const trigger = dropdownElement.closest(AREA_HOVER_SELECTOR)

      setTimeout(() => {
        // 遅延後にマウスがトリガーまたはドロップダウン上にない場合のみ非アクティブに
        removeActiveState(trigger, dropdownElement)
      }, 100)
    })
  })

  // ChannelIO workflow イベントリスナー
  document.querySelectorAll('.js-ChannelIO-openWorkflow').forEach(element => {
    element.addEventListener('click', (event) => {
      event.preventDefault(); // デフォルトのリンク動作を防ぐ
      
      if (typeof window.ChannelIO === 'function') {
        window.ChannelIO('openWorkflow', element.dataset.channelId)
      } else {
        // ChannelIOが埋め込まれていない環境で正しく呼ばれていることを確認するためconsole.logを仕込む
        console.log(`call ChannelIO openWorkflow ${element.dataset.channelId}`)
      }
    })
  })
})
